// extracted by mini-css-extract-plugin
export var divider = "_r0-0";
export var systemMessage = "_r0-1";